import React from "react";
import { graphql, useStaticQuery } from "gatsby";

const query = graphql`
  query SEO {
    sanitySitesettings {
      favicon {
        asset {
          url
        }
      }
    }
    site {
      siteMetadata {
        defaultTitle: title
        siteUrl: siteUrl
      }
    }
  }
`;
function Seo({ children, location, data }) {
  const { site, sanitySitesettings } = useStaticQuery(query);

  const { defaultTitle, defaultDescription, siteUrl } = site.siteMetadata;
  const seo = {
    title: data?.title || defaultTitle,
    description: data?.description || defaultDescription,
    url: `${siteUrl}${location.pathname}`,
    image: data?.image || null,
  };

  const imageUrl =
    seo.image && typeof seo.image === "string"
      ? seo.image.startsWith("http")
        ? seo.image
        : `${siteUrl}${seo.image}`
      : null;

  return (
    <>
      <title>{seo.title}</title>
      {sanitySitesettings?.favicon && (
        <link
          rel="icon"
          type="image/x-icon"
          href={sanitySitesettings.favicon.asset.url}
        ></link>
      )}
      <meta name="description" content={seo.description} />
      <meta name="theme-color" content="#ffffff" />
      <meta name="msapplication-navbutton-color" content="#ffffff" />
      <meta name="apple-mobile-web-app-status-bar-style" content="#ffffff" />
      {seo?.url && <meta property="og:url" content={seo.url} />}
      {seo?.title && <meta property="og:title" content={seo.title} />}
      {seo?.description && (
        <meta property="og:description" content={seo.description} />
      )}
      {imageUrl && <meta property="og:image" content={imageUrl} />}
      {imageUrl && <meta property="og:image:secure_url" content={imageUrl} />}
      <meta property="og:site_name" content="upriseenergy.com" />
      <meta name="twitter:card" content="summary_large_image" />
      {seo?.title && <meta name="twitter:title" content={seo.title} />}
      {seo?.description && (
        <meta name="twitter:description" content={seo.description} />
      )}
      {imageUrl && <meta name="twitter:image" content={imageUrl} />}
      {data?.keywords?.length > 0 && (
        <meta name="keywords" content={data.keywords.join(",")} />
      )}
      {data?.ldSchema?.length > 0 &&
        data.ldSchema.map((item, index) => (
          <script type="application/ld+json" key={index}>
            {JSON.parse(item)}
          </script>
        ))}
      {children}
    </>
  );
}

export default Seo;
